export default __webpack_public_path__ + "static/media/schools.fdb57c94.svg";